export class Analytics {
    trackPage(options) {
        console.warn("Analytics.trackPage", options);
        // if (options && options.url) {
        //     ga('send', 'pageview', options.url);
        // } else {
        //     ga('send', 'pageview');
        // }
    }

    trackEvent(options) {
        console.warn("Analytics.trackEvent", options);
        // if (options) {
        //     if (options.category && options.action && options.label) {
        //         ga("send", "event", options.category, options.action, options.label);
        //     } else if (options.category && options.action) {
        //         ga("send", "event", options.category, options.action);
        //     }
        // }
    }
}



// WEBPACK FOOTER //
// ../clients/Analytics.js